

export enum MaterializationEnum {

  BOOK = 'book'

}
